import {
  GET_DICTIONARY_GIMS_SECTIONS,
  GET_DICTIONARY_NSI_CHECK_STATUS,
  GET_USERS_LIBRARY,
  GET_ATE_LIBRARY,
  GET_APP_REG_STATUS_LIBRARY,
  GET_TRAINING_PROGRAM_LIBRARY,
  GET_DICTIONARY_STATUS_ISSUANCE_CERTIFICATES,
  NEW_GET_DICTIONARY_NSI_CHECK_STATUS,
  GET_VALID_TYPES_LIBRARY,
  GET_VALID_ZONES_LIBRARY,
  GET_GIMS_DEPARTMENT_ALL,
  GET_ALL_OBLAST,
  GET_GIMS_USER_POSITIONS_ALL,
  GET_SWIMMING_DIFFICULTY_CATEGORY_ALL,
  GET_PREPARATION_PROGRAMS_ALL,
  GET_PAYMENT_DETAILS_ALL,
  GET_LOCALITY_CATEGORY_ALL,
  GET_ALL_IDENTIFICATION_DOCUMENTS,
  GET_ALL_BOAT_TYPES,
  GET_MED_CONDITIONS_ALL,
  GET_TRAINING_DOC_TYPES_ALL,
  GET_TRAINING_EXAM_TYPES_ALL,
  GET_ALL_KINDS_BOATS,
  GET_ENGINE_TYPES_ALL,
  GET_BOAT_BODY_MATERIAL_ALL,
  GET_ROLES_ALL,
  GET_USER_INFO,
  GET_AUDIT_OBJECT,
  GET_RANGE_MS_ALL,
  GET_NSI_AP,
  GET_ALL_BILL_STATUS,
  GET_ALL_PAID_PROC_TYPES,
  GET_ALL_INF_PAYMENT_AP,
  GET_ALL_COUNTRIES,
  GET_ALL_TRAINING_ORGANIZATIONS,
  GET_ALL_AUDIT_SECURITY_EVENTS,
  GET_GIMS_SUB_LEVELS,
  DELETE_USER_INFO,
} from "../types";

const initialState = {
  isLoading: true,
  gimsSections: [],
  nsiCheckStatus: [],
  newNsiCheckStatus: [],
  usersLibrary: [],
  ateLibrary: [],
  appRegStatusLibrary: [],
  trainingProgramLibrary: [],
  statusIssuanceCertificates: [],
  validZones: [],
  validTypes: [],
  departmentAll: [],
  allOblast: [],
  allAuditObject: [],
  allGimsUserPositions: [],
  allSwimmingDifficultyCategory: [],
  allPreparationPrograms: [],
  allPaymentDetails: [],
  identificationDocuments: [],
  allLocalityCategory: [],
  allMedConditions: [],
  allTrainingDocTypes: [],
  boatTypes: [],
  allEngineTypes: [],
  allBoatBodyMaterial: [],
  kindsBoats: [],
  allRoles: [],
  userInfo: {},
  allRangeMS: [],
  allTrainingExamTypes: [],
  allBillStatus: [],
  allPaidProcTypes: [],
  allInfPaymentAp: [],
  allCountries: [],
  allTrainingOrganizations: [],
  allAuditSecurityEvents: [],
  allGimsSubLevels: [],
};

export const dictionaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DICTIONARY_GIMS_SECTIONS:
      return (() => ({
        ...state,
        isLoading: false,
        gimsSections: [...action.data],
      }))();
    case GET_DICTIONARY_NSI_CHECK_STATUS:
      return (() => ({
        ...state,
        nsiCheckStatus: action.data.map((status) => {
          return {
            id: status.statusId,
            value: status.statusName,
          };
        }),
      }))();
    case NEW_GET_DICTIONARY_NSI_CHECK_STATUS:
      return (() => ({
        ...state,
        newNsiCheckStatus: [...action.data],
      }))();
    case GET_USERS_LIBRARY:
      return (() => ({
        ...state,
        usersLibrary: [...action.data],
      }))();
    case GET_ATE_LIBRARY:
      return (() => ({
        ...state,
        ateLibrary: [...action.data],
      }))();
    case GET_APP_REG_STATUS_LIBRARY:
      return (() => ({
        ...state,
        appRegStatusLibrary: [...action.data],
      }))();
    case GET_TRAINING_PROGRAM_LIBRARY:
      return (() => ({
        ...state,
        trainingProgramLibrary: [...action.data],
      }))();
    case GET_AUDIT_OBJECT:
      return (() => ({
        ...state,
        allAuditObject: [...action.data],
      }))();
    case GET_DICTIONARY_STATUS_ISSUANCE_CERTIFICATES:
      return (() => ({
        ...state,
        statusIssuanceCertificates: [...action.data],
      }))();
    case GET_VALID_TYPES_LIBRARY:
      return (() => ({
        ...state,
        validTypes: [...action.data],
      }))();
    case GET_VALID_ZONES_LIBRARY:
      return (() => ({
        ...state,
        validZones: [...action.data],
      }))();
    case GET_GIMS_DEPARTMENT_ALL:
      return (() => ({
        ...state,
        departmentAll: action.data,
      }))();
    case GET_ALL_OBLAST:
      return (() => ({
        ...state,
        allOblast: [...action.data],
      }))();
    case GET_GIMS_USER_POSITIONS_ALL:
      return (() => ({
        ...state,
        allGimsUserPositions: [...action.data],
      }))();
    case GET_SWIMMING_DIFFICULTY_CATEGORY_ALL:
      return (() => ({
        ...state,
        allSwimmingDifficultyCategory: [...action.data],
      }))();
    case GET_PREPARATION_PROGRAMS_ALL:
      return (() => ({
        ...state,
        allPreparationPrograms: [...action.data],
      }))();
    case GET_RANGE_MS_ALL:
      return (() => ({
        ...state,
        allRangeMS: [...action.data],
      }))();
    case GET_NSI_AP:
      return (() => ({
        ...state,
        allNsiAp: [...action.data],
      }))();
    case GET_PAYMENT_DETAILS_ALL:
      return (() => ({
        ...state,
        allPaymentDetails: [...action.data],
      }))();
    case GET_LOCALITY_CATEGORY_ALL:
      return (() => ({
        ...state,
        allLocalityCategory: [...action.data],
      }))();
    case GET_ALL_IDENTIFICATION_DOCUMENTS: {
      return {
        ...state,
        identificationDocuments: action.data,
      };
    }
    case GET_ALL_BOAT_TYPES: {
      return {
        ...state,
        boatTypes: action.data,
      };
    }
    case GET_MED_CONDITIONS_ALL: {
      return {
        ...state,
        allMedConditions: action.data,
      };
    }
    case GET_TRAINING_DOC_TYPES_ALL: {
      return {
        ...state,
        allTrainingDocTypes: action.data,
      };
    }
    case GET_TRAINING_EXAM_TYPES_ALL: {
      return {
        ...state,
        allTrainingExamTypes: action.data,
      };
    }
    case GET_ENGINE_TYPES_ALL: {
      return {
        ...state,
        allEngineTypes: action.data,
      };
    }
    case GET_BOAT_BODY_MATERIAL_ALL: {
      return {
        ...state,
        allBoatBodyMaterial: action.data,
      };
    }
    case GET_ALL_KINDS_BOATS: {
      return {
        ...state,
        kindsBoats: action.data,
      };
    }
    case GET_ROLES_ALL: {
      return {
        ...state,
        allRoles: action.data,
      };
    }
    case GET_USER_INFO: {
      return {
        ...state,
        userInfo: action.data,
      };
    }
    case DELETE_USER_INFO: {
      return {
        ...state,
        userInfo: {},
      };
    }
    case GET_ALL_BILL_STATUS: {
      return {
        ...state,
        allBillStatus: action.data,
      };
    }
    case GET_ALL_PAID_PROC_TYPES: {
      return {
        ...state,
        allPaidProcTypes: action.data,
      };
    }
    case GET_ALL_INF_PAYMENT_AP: {
      return {
        ...state,
        allInfPaymentAp: action.data,
      };
    }
    case GET_ALL_COUNTRIES: {
      return {
        ...state,
        allCountries: action.data,
      };
    }
    case GET_ALL_TRAINING_ORGANIZATIONS: {
      return {
        ...state,
        allTrainingOrganizations: action.data,
      };
    }
    case GET_ALL_AUDIT_SECURITY_EVENTS: {
      return {
        ...state,
        allAuditSecurityEvents: action.data,
      };
    }
    case GET_GIMS_SUB_LEVELS: {
      return {
        ...state,
        allGimsSubLevels: action.data,
      };
    }
    default:
      return state;
  }
};
